import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Pagination,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { getadministrationList } from "../../api/api";
import MemberTable from "./components/memberTable/memberTable";
import NewMember from "./components/newMember/newMember";
import "./index.css";

const { RangePicker } = DatePicker;
const MemberManage = () => {
  const [componentSize, setComponentSize] = useState("default");
  const [payload, setPayload] = useState({ page: "1", pagesize: "10" });
  const [total, setTotal] = useState(0);
  const [form] = useForm();
  const memberRef = useRef();
  const [isFresh, setIsFresh] = useState(false);

  useEffect(() => {
    getadministrationList({ params: payload }).then((res) => {
      //  console.log(res.data.data)
      const info = res.data.data;
      if (info.total === 0) {
        message.error("未能找到指定条件内容！");
      }
      memberRef.current.changeData(res.data.data.rows);
      setTotal(res.data.data.total);
    });
  }, [payload, isFresh]);

  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size);
  };

  const handleSubmit = (values) => {
    let payload = {
      page: "1",
      pagesize: "10",
      name_or_nickname: values.name_or_nickname,
      authority: values.authority,
    };

    setPayload(payload);
  };

  const resetSelectors = () => {
    form.resetFields();
  };
  const pageChange = (e) => {
    //分页改变的回调
    setPayload({
      ...payload,
      page: e,
    });
  };
  return (
    <div className="memberManage">
      <Form
        initialValues={{
          size: componentSize,
        }}
        onValuesChange={onFormLayoutChange}
        onFinish={handleSubmit}
        size={componentSize}
        form={form}
      >
        <Row>
          <Col span={7} offset={1}>
            <Form.Item
              label="成员信息"
              name="name_or_nickname"
              className="memberContent"
            >
              <Input placeholder="请输入成员昵称/用户名" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="角色"
              name="authority"
              className="role"
              labelCol={{ span: 4 }}
            >
              <Select
                placeholder="请选择"
                style={{ textAlign: "left" }}
                getPopupContainer={(e) => e}
              >
                <Select.Option value="1">超级管理员</Select.Option>
                <Select.Option value="2">管理员</Select.Option>
                <Select.Option value="3">审核员</Select.Option>
                <Select.Option value="4">房源管理员</Select.Option>
                <Select.Option value="5">内容管理员</Select.Option>
                <Select.Option value="6">活动管理员</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item>
              <Button onClick={resetSelectors} style={{ marginRight: "20px" }}>
                重置
              </Button>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Col>

          <Col span={4} offset={2}>
            {" "}
            <NewMember setIsFresh={setIsFresh} />
          </Col>
        </Row>
      </Form>
      <MemberTable ref={memberRef} setIsFresh={setIsFresh} />
      <Pagination
        showQuickJumper
        style={{ textAlign: "right" }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  );
};
export default MemberManage;
